// extracted by mini-css-extract-plugin
module.exports = {"articleNumber":"orderRows_articleNumber__1WCPx","articleDescription":"orderRows_articleDescription__2nBbR","cell":"orderRows_cell__iop3v"};